import { Box, Container, Grid } from "@mui/material";
import { useState } from "react";
import TopBar from "../../../components/TopBar/TopBar";
import "./ClinicPet.css";
import ClinicPetsTable from "./ClinicPetsTable";
import PetMaster from "./Master/PetMaster";
import Main from "./PetCharts.js/Main";

const ClinicPets = () => {
  const [selectedTab, setSelectedTab] = useState("contents");

  return (
    <>
      {/* Tab Navigation - Same pattern as Appointments.js */}
      <TopBar>
        <Container maxWidth="xl">
          <Grid container spacing={0} className="flex-center">
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <Grid container spacing={0}>
                <div className="flex-row">
                  <div
                    className="ph10pv3"
                    onClick={() => setSelectedTab("charts")}
                  >
                    <div
                      className={`flex-center cursor ${
                        selectedTab === "charts"
                          ? "pet-det-sel-tab"
                          : "pet-det-un-sel-tab"
                      }`}
                    >
                      Dashboard
                    </div>
                  </div>
                  <div
                    className="ph10pv3"
                    onClick={() => setSelectedTab("contents")}
                  >
                    <div
                      className={`flex-center cursor ${
                        selectedTab === "contents"
                          ? "pet-det-sel-tab"
                          : "pet-det-un-sel-tab"
                      }`}
                    >
                      Contents
                    </div>
                  </div>
                  <div
                    className="ph10pv3"
                    onClick={() => setSelectedTab("master")}
                  >
                    <div
                      className={`flex-center cursor ${
                        selectedTab === "master"
                          ? "pet-det-sel-tab"
                          : "pet-det-un-sel-tab"
                      }`}
                    >
                      Master
                    </div>
                  </div>
                </div>
              </Grid>
            </Grid>
          </Grid>
        </Container>
      </TopBar>

      {/* Tab Content */}
      {/* Tab Content */}
      {selectedTab === "charts" ? (
        <Box
          sx={{
            height: "calc(100vh - 120px)",
            overflow: "auto",
            padding: "20px",
          }}
        >
          <Main />
        </Box>
      ) : null}
      {selectedTab === "contents" ? <ClinicPetsTable /> : null}
      {selectedTab === "master" ? <PetMaster /> : null}
    </>
  );
};

export default ClinicPets;
